import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { CompanyAuditService } from '../../services/company-audit.service';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ViewChild } from '@angular/core';
import { DocumentModel } from '../../models/document.model';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class DocumentComponent implements OnInit {
    errors: string[];
    @Input() companyAuditId: string;
    @Input() moduleId: string;
    @Output() documentUploaded: EventEmitter<string> = new EventEmitter<string>();
    public config: DropzoneConfigInterface = {
        url: '/api/CompanyAudit/upload-document/',
        clickable: true,
        maxFiles: 50,
        autoQueue: false,
        autoProcessQueue: false,
        autoReset: null,
        errorReset: null,
        cancelReset: null,
        addRemoveLinks: true,
        createImageThumbnails: true,
        dictRemoveFileConfirmation: 'Are you sure?',
        dictDefaultMessage: '<h3><span class="fa fa-cloud-upload"></span> Drag your document onto this area to upload</h3>'
    };
    @ViewChild(DropzoneComponent, { static: false }) componentRef?: DropzoneComponent;
    documents: DocumentModel[] = [];
    documentForm: FormGroup;
    files: File[] = [];

    token: string;

    constructor(
        private fb: FormBuilder,
        private companyAuditService: CompanyAuditService
    ) {
    }

    ngOnInit() {

    }

    getDocuments(): void {
        const dropzone = this.componentRef.directiveRef.dropzone();
        this.companyAuditService.getDocuments(this.moduleId).subscribe(
            documents => {
                this.documents = documents;
            },
            error => this.errors = error.errorList
        );
    }

    ngAfterViewInit() {
        (document.querySelector('.dz-message') as HTMLElement).style.height = '80px';
        this.getDocuments();
    }

    public onUploadError(args: any): void {
        console.log('onUploadError:', args);
    }

    public onAddedfile(args: any): void {
        this.files.push(args);
        this.documentForm = this.fb.group(
            {
                documentId: args.upload.uuid,
                moduleId: this.moduleId,
                companyAuditId: this.companyAuditId
            }
        );
        this.companyAuditService
            .upload(this.files, this.documentForm.value)
            .subscribe(result => {
                this.files = [];
                this.getDocuments();
                this.documentUploaded.emit(args);
            });
    }


    public onSending(args: any): void {
        let uuid = args[0].upload.uuid;
        args[2].append('documentId', uuid);
    }

}
